module.exports = __webpack_public_path__ + "static/media/hangman6.f10a8a81.png";